const px = (value) => {
    if (typeof value === 'number')
        return `${value}px`;
    return value;
};

export { px };
//# sourceMappingURL=px.js.map
